function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}
module.exports = _isFunction;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_isFunction.js
// module id = 747
// module chunks = 168707334958949